import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { ArrowLeft, Mail, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur — réessayez dans un instant.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-white text-[#1a2332] font-body" data-testid="forgot-password-page">
      <div className="lg:w-1/2 relative overflow-hidden p-8 lg:p-16 flex flex-col justify-between bg-[#080C0E] text-white">
        <Link to="/login" className="inline-flex items-center gap-2 text-white/70 hover:text-white w-fit" data-testid="back-login">
          <ArrowLeft className="w-4 h-4" /> Retour à la connexion
        </Link>
        <div>
          <img src="/brand/logo.png" alt="DDSEmpire" className="w-16 h-16 rounded-xl object-contain" />
          <h1 className="mt-8 font-headings font-black text-4xl md:text-5xl leading-tight">Mot de passe<br />oublié ?</h1>
          <p className="mt-5 text-white/65 max-w-md text-lg">Entrez votre adresse email, nous vous envoyons un lien pour en choisir un nouveau.</p>
        </div>
        <div className="text-xs text-white/50">
          DDSEmpire · 37 Av. Édouard Vaillant, 92100 Boulogne-Billancourt · 01 41 31 50 61
        </div>
      </div>

      <div className="lg:w-1/2 flex items-center justify-center p-8">
        {sent ? (
          <div className="w-full max-w-sm text-center" data-testid="forgot-sent">
            <div className="w-14 h-14 mx-auto rounded-full bg-[#00a86b]/10 text-[#00a86b] flex items-center justify-center">
              <Check className="w-7 h-7" />
            </div>
            <h2 className="mt-5 font-headings font-black text-2xl">Vérifiez votre boîte mail</h2>
            <p className="mt-3 text-[#5b6577] leading-relaxed">Si un compte existe pour <strong className="text-[#1a2332]">{email}</strong>, vous recevrez sous 1 à 2 minutes un email avec un lien de réinitialisation valable 30 minutes.</p>
            <p className="mt-4 text-sm text-[#5b6577]">Pensez à vérifier votre dossier <strong>spam / courrier indésirable</strong>.</p>
            <Link to="/login" className="mt-8 inline-flex items-center gap-2 text-[#00a86b] hover:underline font-headings font-bold text-sm">
              <ArrowLeft className="w-4 h-4" /> Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="w-full max-w-sm" data-testid="forgot-form">
            <h2 className="font-headings font-black text-3xl">Réinitialiser</h2>
            <p className="mt-2 text-[#5b6577]">Un lien sécurisé vous sera envoyé par email.</p>

            <label className="block mt-8">
              <span className="font-headings font-semibold text-sm">Email</span>
              <div className="relative mt-2">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#9aa5bc]" />
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email"
                  className="w-full rounded-xl border-2 border-[#e5eaf3] focus:border-[#00a86b] outline-none pl-10 pr-4 py-3 font-body" placeholder="vous@ddsbillancourt.fr" />
              </div>
            </label>

            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#FF8C42] hover:bg-[#e8763a] disabled:opacity-60 text-white font-headings font-bold rounded-xl px-7 py-3.5 shadow-lg transition-all">
              {loading ? "Envoi…" : "Envoyer le lien"}
            </button>

            <p className="mt-6 text-xs text-[#5b6577]">
              Pas encore de compte ? Contactez votre auto-école au 01 41 31 50 61.
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
